import { render } from "./comment-item.vue?vue&type=template&id=322df594&scoped=true&ts=true"
import script from "./comment-item.vue?vue&type=script&lang=ts"
export * from "./comment-item.vue?vue&type=script&lang=ts"

import "./comment-item.vue?vue&type=style&index=0&id=322df594&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Link\\Documents\\MCOM\\mcom-agri-origin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-322df594"]])

export default __exports__